import type { Facets } from '@ahd/shared/types/ahd-fleet-api/facets';
import type { FleetCar } from '@ahd/shared/types/ahd-fleet-api/fleet-car/car';
import type { Filter } from '@ahd/shared/types/ahd-fleet/filter';
import type { UseFormSetValue } from 'react-hook-form';
import type { NavigateFunction } from 'react-router';

import type { FormProviderProps } from '../../components/hook-form/form-provider/types';

export enum ViewOptionsView {
    Grid = 'grid',
    List = 'list',
}

export interface ViewOptions {
    advanced?: boolean;
    view?: ViewOptionsView;
}

export type UseCarSearchForm = Filter & { afterSubmit?: string };

export interface UseCarSearchProps {
    disableAutoLoad?: boolean;
    navigate?: NavigateFunction;
    params?: Readonly<Partial<Record<'hersteller' | 'modell' | 'typ' | 'standort' | 'carDesign' | 'carId', string>>>;
    query?: URLSearchParams;
}

export interface UseCarSearchReturn {
    /** Result list of cars */
    cars: FleetCar[];
    /** Result list of facets */
    facets: Facets;
    /** FormProvider props */
    formProviderProps: Pick<FormProviderProps, 'formKey' | 'methods' | 'onSubmit'>;
    /** Indicates if search is still ongoing */
    loading: boolean;
    /** Indicates if more cars are still loading */
    loadingMore: boolean;
    /** Total number of found cars */
    numFound: number;
    /** Reset filters (function is undefined, if there is nothing to reset) */
    reset: () => void | undefined;
    setValue: UseFormSetValue<UseCarSearchForm>;
    values: UseCarSearchForm;

    /*
    methods: UseFormReturn<UseCarSearchForm, any, UseCarSearchForm>;
     */
}
